<template>
	<div class="follow">
		<CubePage type="myorder-view" title="关注公众号" :isback="false">
			<div slot="content" class="content">
				<div class="">
					<img style="width: 100%;" src="@/assets/img/follownew.jpg" alt="">
				</div>
			<!-- 	<div class="item">
					<div class="flex">
						<van-icon name="wechat" />
						<p>微信搜一搜</p>
					</div>
					<div class="msearch">
						<van-icon name="search" />
						<span>智慧旅业</span>
					</div>
					<div class="imgcore">
						<img src="@/assets/img/recode.jpg" alt="">
					</div>
					<p class="remark" v-if="type">扫码关注微信公众号，回复<a>获取核销码</a></p>
					
					<div class="tt" v-else>
						<p>如需帮助</p>
						<p>请关注公众号"智慧旅业"</p>
						<p>客服热线：18081129177</p>
					</div>
				</div> -->
			</div>
		</CubePage>
	</div>
</template>

<script>
	import CubePage from '../TP/cube-page.vue'
	import * as util from '@/utils/network'
	import wx from 'weixin-js-sdk'
	import {
		Dialog
	} from 'vant';
	export default {
		components: {
			CubePage
		},
		data() {
			return {
				type: this.$route.query.type
			}
		},
		methods: {

		},
	}
</script>
<style lang="less" scoped="scoped">
	// /deep/ .cube-page>.wrapper {
	// 	background-color: #00c7bd;
	// }

	.content {
		padding: 10px;
		box-sizing: border-box;
		color: #fff;

		.imgcore {
			margin-top: 15px;
			height: 220px;
			width: 220px;
			border-radius: 15px;
			background-color: #fff;
			display: flex;
			align-items: center;
			justify-content: center;

			.van-image {
				width: 200px;
			}
		}

		.item {
			display: flex;
			flex-direction: column;
			align-items: center;
			justify-content: center;
			margin-top: 30px;

			.remark {
				padding: 25px;
				font-size: 16px;
				font-weight: 600;
			}

			.tt {
				padding-top: 20px;
				margin-top: 5px;
				text-align: center;
				font-weight: 600;
				line-height: 26px;
			}

			.flex {
				display: flex;
				align-items: center;

				.van-icon {
					font-size: 48px;
					padding-right: 10px;
				}
			}

			.msearch {
				margin: 10px 0;
				height: 30px;
				padding: 0 10px;
				line-height: 30px;
				background-color: #fff;
				border-radius: 5px;
				color: #000;
			}
		}
	}
</style>
